import React, { Component } from 'react';
import { Row, Col, Form, Input } from 'antd';

class Source extends Component {
  constructor(props) {
    super(props);

    let json = {};

    if (props.json) {
      try {
        const parsed = JSON.parse(props.json);
        json = parsed.SOURCE ? parsed.SOURCE : {};
      } catch (e) {
        json = {};
      }
    }

    this.state = {
      source: json.source ? json.source : '',
      isValidSource: '',
    };
  }

  submitState = () => {
    const { source } = this.state;
    let isEntireFormValid = true;
    let statesToReturn = {};

    if (source && source.trim()) {
      statesToReturn.source = source;
    } else {
      isEntireFormValid = false;
      this.setState({
        isValidSource: 'input-error',
      });
    }

    return isEntireFormValid ? statesToReturn : false;
  };

  saveState = () => {
    return {
      source: this.state.source,
    };
  };

  onChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      [name]: value,
    });
  };

  onBlur = (e) => {
    const key = e.target.getAttribute('name');
    const inputValue = e.target.value;
    const isRequired = e.target.getAttribute('data-required');

    let newValue = '';
    const validator = () => true;

    if (inputValue.length) {
      newValue = validator(inputValue) ? '' : 'input-error';
    } else {
      newValue = isRequired === 'true' ? 'input-error' : '';
    }

    if (key === 'source') {
      this.setState({
        isValidSource: newValue,
      });
    }
  };

  onFocus = (e) => {
    const key = e.target.getAttribute('name');
    const isRequired = e.target.getAttribute('data-required');

    if (isRequired === 'true' && key === 'source') {
      this.setState({
        isValidSource: 'input-error',
      });
    }
  };

  render() {
    const { source, isValidSource } = this.state;

    return (
      <div className="form-horizontal">
        <Row gutter={16}>
          <Col xs={24} sm={12}>
            <Form.Item
              label="Specimen Source"
              validateStatus={isValidSource === 'input-error' ? 'error' : ''}
              help={isValidSource === 'input-error' ? 'Specimen Source is required' : ''}
              labelCol={{ xs: 24, sm: 8 }}
              wrapperCol={{ xs: 24, sm: 16 }}
            >
              <Input
                name="source"
                value={source}
                aria-describedby="source"
                data-required="true"
                onChange={this.onChange}
                onFocus={this.onFocus}
                onBlur={this.onBlur}
              />
            </Form.Item>
          </Col>
        </Row>
      </div>
    );
  }
}

export default Source;